import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router'
import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import ReckonLogo from './logo-icon.png';
import APSLogo from './aps-logo.png';
import css from './login.css'
import * as actions from '../../Actions/bankfeeds';


class Header extends React.Component {

  componentDidMount() {
    const token = localStorage.getItem('token');
    const url = this.props.location.search;
    const isClientAccess = !(url.includes('cognitotoken') || url.includes('isR1'))

    if (token) {
      this.props.validateToken();
    }
    if (isClientAccess) {
      this.loadBackground();
    }
  }

  onLogout = () => {
    this.props.logout();
    this.props.history.push('/logout');
  }

  loadBackground = () => {
    document.body.style.background = 'url(https://ddvqhbgjmdkmq.cloudfront.net/wp-content/uploads/sites/2/2016/01/19011216/Background-slider-homepage_01.jpg) #214a5e no-repeat 50% fixed';
    document.body.style.backgroundSize = 'cover'
  }

  render() {
    const theme = createMuiTheme({
        palette: {
            secondary: { main: '#262626' },
        },
    });

    const { xpa, location } = this.props;
    const currentPage = location.pathname;
    const bookid = localStorage.getItem('bookid');
    const cognitotoken = localStorage.getItem('cognitotoken');
    const xpaPage = `/xpa/${bookid}`;
    const loginPage = `/book/${bookid}`;
    const noAccessPage = `/book/`;
  
    if (currentPage !== xpaPage && xpa.loggedIn === true) {
        return <Redirect to={xpaPage} />;
    }
    if (currentPage !== loginPage && currentPage !== noAccessPage && xpa.loggedIn === false) {
      if (cognitotoken) {
        localStorage.removeItem('cognitotoken');
        return <Redirect to={noAccessPage} />;
      }
      return <Redirect to={loginPage} />;
    }
  
    return (
        <div>
            <ThemeProvider theme={theme}>
                <AppBar style={{ background: `${cognitotoken ? '#2E3B55' : '#000'}` }}>
                    <Toolbar>
                        <div className={css.headerLeft}>
                            <img src={cognitotoken ? APSLogo : ReckonLogo} style={{ maxHeight: '50px' }} />
                        </div>
                        { xpa.loggedIn && (
                          <div className={css.flexRow}>
                            { xpa.user && 
                            <div className={css.loginInfo}>
                              {`${xpa.user.username || ''}`}
                            </div> }
                            <Button onClick={this.onLogout} color="inherit"> Logout </Button>
                          </div>
                        )}
                    </Toolbar>
                </AppBar>
            </ThemeProvider>
        </div>
      );
  }
}

function mapStateToProps(state) {
    const { xpa } = state;
    return { xpa };
  }
  
Header = connect(
  mapStateToProps, 
  actions
)(Header);

export default withRouter(Header);


// WEBPACK FOOTER //
// ./src/components/Portal/Header.js